<div [ngClass]="{ position: position, colour: colour, 'corner-ribbon': true }" [title]="hoverText">{{ text }}</div>
